import { render, staticRenderFns } from "./personChoose.vue?vue&type=template&id=d32ccd02&scoped=true&lang=pug"
import script from "./personChoose.vue?vue&type=script&lang=js"
export * from "./personChoose.vue?vue&type=script&lang=js"
import style0 from "./personChoose.vue?vue&type=style&index=0&id=d32ccd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32ccd02",
  null
  
)

export default component.exports